import React, {Component} from 'react';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';
import {Link} from 'react-router-dom';
import {Grid} from 'react-bootstrap';

import CardsPersonal from 'system/cards-personal';
import Breadcrumbs from '../../breadcrumbs';
import {Wrapper} from 'system/wrapper';
import Input from 'form/input';
import {Divider, Label, SelectWithSearchAsync} from 'components/common';
import Spinner from 'spinner';
import Pagination from 'pagination';
import {ButtonDefault} from 'components/buttons';
import {SearchFormWrapper} from './components';

import {searchAllPersonal, searchMedicalInstitutions, loadClasifications} from 'redux/actions/portal/institutions';
import doctor from 'images/general/doctor.svg';


const mapStateToProps = (state) => ({
  personal: state.institutions.get('institutionPersonal'),
  institutions: state.institutions.get('institutionsList'),
  isLoading: state.institutions.get('institutionsIsLoading'),
  professions: state.institutions.get('professions'),
  isLoaded: state.institutions.get('institutionsLoaded')
});

const mapDispatchToProps = (dispatch) => ({
  onLoad: (limit, offset) => dispatch(searchAllPersonal(12, offset)),
  loadProfessions: search => dispatch(loadClasifications(search)),
  loadInstitutions: search => dispatch(searchMedicalInstitutions(search)),
  onSearch: (name, institution, profession, limit, offset) => dispatch(searchAllPersonal(name, institution, profession, "0200", 12, offset))
});


class Records extends Component {

  constructor(props) {
    super(props);

    this.state = {
      name: "",
      institution: '',
      profession: '',
      notFound: false,
      professionSelect: '',
      institutionSelect: ''
    }

    this.changeSearchName = this.changeSearchName.bind(this);
  }

  selectWithSearchStyle = {
    border: 'none'
  }

  onChangeInstitutions = institution => {
    let institutionValue = institution ? institution.value : ''
    this.setState({
      institutionSelect: institution,
      institution: institutionValue
    });
  }

  onChangeProfession = profession => {
    let professionValue = profession ? profession.value : ''
    this.setState(() => ({
      professionSelect: profession,
      profession: professionValue
    }))
  }

  generateProfessionOptions = results => {
    return results.reduce((arr, item) => {
      const newOption = {value: item.get('id'), label: item.get('profession_title')}
      arr.push(newOption)
      return arr
    }, [])
  }

  loadProfessions = search => {
    if (!search) search=''
    return this.props.loadProfessions(search)
      .then(results => {
        if(!results.size) return Promise.resolve({ options: [] })
        const options = this.generateProfessionOptions(results)
        return { options }
      })
  }

  generateInstitutionOptions = results => {
    return results.reduce((arr, item) => {
      const newOption = {value: item.get('id'), type: item.get('institution_type'), label: item.get('full_title') }
      arr.push(newOption)
      return arr
    }, [])
  }

  loadInstitutions = search => {
    if (!search) search=''
    return this.props.loadInstitutions(search)
      .then(response => {
        const results = response.get('results')
        if(!results.size) return Promise.resolve({ options: [] })
        const options = this.generateInstitutionOptions(results)
        return { options }
      })
  }

  changeSearchName(event) {
    this.setState({
      name: event.target.value
    })
  }

  handleSearchClick = event => {
    event.preventDefault();
    this.props.match.params.page == 1
      ? this.props.onSearch(this.state.name, this.state.institution, this.state.profession)
      : this.props.history.push(`/records/1`)

  }

  componentDidMount() {
    const page = this.props.match.params.page || 1;
    const offset = 12 * (page - 1);
    this.props.onLoad(offset)
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.match.params.page !== nextProps.match.params.page) {
      const page = nextProps.match.params.page || 1;
      const offset = 12 * (page - 1);
      this.props.onSearch(this.state.name, this.state.institution, this.state.profession, 12, offset)
    }
    const isSearchQuery = this.state.name || this.state.institution || this.state.profession
    if (isSearchQuery && nextProps.personal && nextProps.personal.get('results').size === 0){
      this.setState(() => ({ notFound: true }))
    }
  }

  render() {

    if (!this.props.personal) {
      return (
        <Wrapper>
          <Spinner/>
        </Wrapper>
      );
    }

    return(
      <div>
        <Breadcrumbs>
          <li><Link to="/">Головна</Link></li>
          <li><Link to="/records">Запис до лікаря</Link></li>
        </Breadcrumbs>
        <Wrapper>
          <Grid>
            <h2>Запис до лікаря</h2>
            <form onSubmit={this.handleSearchClick}>
            <SearchFormWrapper>
              <div>
              <Input
                block
                placeholder="Введіть прізвище чи посаду лікаря"
                label="Пошук за прізвищем чи посадою лікаря"
                value={this.state.name}
                onChange={this.changeSearchName}
              />
              </div>
              <div>
                <Label>Виберіть спеціальність лікаря:</Label>
                <SelectWithSearchAsync
                  searchable={true}
                  isSearchable={true}
                  value={this.state.professionSelect}
                  loadOptions={this.loadProfessions}
                  valueKey={'value'}
                  labelkey={'label'}
                  onChange={this.onChangeProfession}
                  style={ this.selectWithSearchStyle }
                  placeholder="Всі спеціальності"
                />
              </div>
            </SearchFormWrapper>
              <Label>Виберіть установу:</Label>
              <SelectWithSearchAsync
                searchable={true}
                isSearchable={true}
                value={this.state.institutionSelect}
                loadOptions={this.loadInstitutions}
                valueKey={'value'}
                labelkey={'label'}
                onChange={this.onChangeInstitutions}
                style={ this.selectWithSearchStyle }
                placeholder="Всі установи"
              />
            <Divider>

            </Divider>
            <Divider>
              <ButtonDefault type="submit" value="Пошук" />
            </Divider>
            </form>

              <div>
              {this.props.personal.get('results').size > 0 ? (
                <div>
                  {this.props.isLoading ? (
                    <Spinner />
                  ):(
                    <CardsPersonal>
                      {this.props.personal.get('results').map((item, i) => (
                        <li key={i}>
                          <Link to={`/institutions/detail/${item.getIn(['institution_data','id'])}/personal/${item.get('id')}`}>
                              {item.getIn(['user_data', 'photo']) ? (
                                  <div style={{width: "60%", backgroundImage: `url(${item.getIn(['user_data','photo'])})`, backgroundSize: "cover", backgroundRepeat: "no-repeat", backgroundPosition: "center"}}> </div>
                              ):(
                                  <div style={{width: "60%", backgroundImage: `url(${doctor})`, backgroundSize: "150px", backgroundRepeat: "no-repeat", backgroundPosition: "center"}}> </div>
                              )}

                            <div style={{maxWidth: '60%', wordWrap: 'break-word'}}>
                            <h3>{item.getIn(['user_data', 'last_name'])} {item.getIn(['user_data', 'first_name'])} {item.getIn(['user_data', 'middle_name'])}</h3>
                            <p><span>Посада: </span>{item.get('position_title')}</p>
                            </div>
                          </Link>
                        </li>
                      ))}
                    </CardsPersonal>
                  )}
                  <Pagination counts={this.props.personal.get('count')} path={`/records/`} matched={this.props.match.params.page} limits={12} />
                </div>
              ):(
                <Divider>
                {this.state.notFound &&
                  <h4>За таким запитом лікарі відсутні</h4>
                }
                </Divider>
              )}
            </div>

          </Grid>
        </Wrapper>
      </div>
    )
  }
}

export default  withRouter(connect(mapStateToProps, mapDispatchToProps)(Records));



// WEBPACK FOOTER //
// ./src/system/main/records/index.js